import { useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GetCurrentDate } from "@services/Utilities";
import { error_message } from "@constants/Errors";
import { KAKELY_PATHS } from "@constants/NavigationPaths";
import { postTenantDepartmentArray } from "@services/API/Requests/TenantDepartmentRequests";

export const UseDepartmentGroupCsvUpload = () => {
  const navigate: NavigateFunction = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const currentDate = GetCurrentDate();

  const noCsvImportError = () => toast.error(error_message.csv.no_data);
  const uploadCsvDataToast = (message) => toast.success(message);
  const failCsvDataToast = (error) => toast.error(`${error}`);
  const [csvData, setCsvData] = useState<[]>([]);
  const [failedDepartments, setFailedDepartments] = useState<[]>();

  const handleCsvUpload = async () => {
    if (csvData.length === 0) {
      noCsvImportError();
      return;
    }

    const departmentDataArray = csvData.map((departmentInfo) => {
      const department = {
        id: departmentInfo.id,
        name: departmentInfo.name,
        name_kana: departmentInfo.name_kana,
        parent: departmentInfo.parent,
        display_order: departmentInfo.display_order,
        department_level: departmentInfo.department_level || 0,
        description: departmentInfo.description || "",
        delete: departmentInfo.delete,
      };

      return department;
    });

    const postDepartmentInformation = async (departmentDataArray) => {
      let response;
      try {
        response = await postTenantDepartmentArray(
          departmentDataArray,
          setLoading,
          setError,
        );
        if (response?.responseMessage.status === 200) {
          const createdCount =
            response?.created_departments?.length ||
            (response?.created_departments.length ? 1 : 0);
          uploadCsvDataToast(
            `${createdCount}件の部署情報を正常に登録しました。`,
          );
          setTimeout(() => {
            navigate(KAKELY_PATHS.allDepartmentSettings);
          }, 1500);
          return;
        } else {
          failCsvDataToast(
            response?.failed_departments?.length +
              "件の部署情報の登録に失敗しました。",
          );
          setFailedDepartments(response?.failed_departments);
        }
      } catch (error) {
        if (departmentDataArray.length == 1 && response?.failed_departments) {
          failCsvDataToast(
            response?.failed_departments?.length +
              "件の部署情報の登録に失敗しました。",
          );
          return;
        }
      }
    };
    await postDepartmentInformation(departmentDataArray);
  };

  const onCancel = () => {
    navigate(KAKELY_PATHS.allDepartmentSettings);
  };

  return {
    loading,
    csvData,
    failedDepartments,
    currentDate,
    handleCsvUpload,
    onCancel,
    setCsvData,
  };
};
